module.exports = __webpack_public_path__ + "static/img/xtd.68146c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xtd.png
// module id = 8a0e
// module chunks = 0